import cx from 'classnames';
import React, { InputHTMLAttributes } from 'react';

import s from './input.module.css';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    name: string;
    label?: string;
    errorText?: string;
    error?: boolean;
    wrapperClassName?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
    (
        { id, name, label, errorText, error = false, className, wrapperClassName, ...props },
        ref
    ): JSX.Element => (
        <div className={cx(s.container, wrapperClassName)}>
            {label && (
                <label htmlFor={id || name} className={s.label}>
                    {label}
                </label>
            )}
            <input
                ref={ref}
                id={id || name}
                name={name}
                className={cx(
                    s.input,
                    {
                        [s.error]: error,
                    },
                    className
                )}
                {...props}
            />
            {error && errorText && <p className={cx(s.errorText, 'annotation')}>{errorText}</p>}
        </div>
    )
);

export default Input;
